import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiShield } = FiIcons;

const LoadingSpinner = () => {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="text-center"
      >
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
          className="inline-block bg-blue-600/20 p-6 rounded-2xl mb-4"
        >
          <SafeIcon icon={FiShield} className="w-16 h-16 text-blue-400" />
        </motion.div>
        <p className="text-slate-400 text-lg">Loading...</p>
      </motion.div>
    </div>
  );
};

export default LoadingSpinner;